<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="card">
        <p class="title">Your Inventory</p>
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Sku</th>
              <th>Quantity</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(product, i) in products">
              <tr :key="i" :class="{ grey: i % 2 }">
                <td data-label="Item">
                  <div class="img-text">
                    {{ product.name }}
                  </div>
                </td>
                <td data-label="Sku">{{ product.sku }}</td>
                <td data-label="Quantity">{{ product.quantity }}</td>
                <td data-label="Details">
                  <img
                    @click="activate(product)"
                    :class="{
                      clickable: !details,
                      active: details == product.id,
                    }"
                    class="action"
                    src="@/assets/img/arrow.svg"
                  />
                </td>
              </tr>

              <transition :key="i" name="fade">
                <tr v-if="details == product.id">
                  <td colspan="100%">
                    <table class="units">
                      <thead>
                        <tr>
                          <td>Color</td>
                          <td>Condition</td>
                          <td>Size</td>
                          <td>Serial Number</td>
                          <td>Client</td>
                          <td>Tracking Number</td>
                          <td>Carrier</td>
                          <td>Order</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="8">
                            {{ product.quantity }} Unassigned units
                          </td>
                        </tr>
                        <tr
                          v-for="item in inventory[product.id]"
                          :key="item.id"
                          class="unit"
                        >
                          <td data-label="Color">{{ item.color }}</td>
                          <td data-label="Condition">{{ item.condition }}</td>
                          <td data-label="Size">{{ item.size }}</td>
                          <td data-label="Serial Number">
                            {{ item.serial_num }}
                          </td>
                          <td data-label="Client">
                            {{
                              `${item.client.first_name} ${item.client.last_name}`
                            }}
                          </td>
                          <td data-label="Tracking Number">
                            {{ item.tracking.number }}
                          </td>
                          <td data-label="Carrier">
                            {{ item.tracking.carrier }}
                          </td>
                          <td data-label="Order Number">{{ 1 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </transition>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;

export default {
  data() {
    return {
      details: null,
    };
  },
  computed: {
    ...mapState(["products", "inventory"]),
  },
  created() {},
  updated() {},
  methods: {
    activate(product) {
      if (this.details == product.id) {
        this.details = null;
      } else {
        this.details = product.id;
      }
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}
</style>
